import {
  ArrowDownward,
  ArrowUpward,
  DeleteForever,
  VisibilityOff,
} from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { observer } from 'mobx-react';
import React, { useRef, useCallback } from 'react';

import { TranslateText } from '../../../../../../../../application/language/TranslateText';
import { ITheoryBlock } from '../../../../../../service/unit/interface/IUnitTheory';
import { IParagraph } from '../../../../../../service/unit/interface/theoryBlocks/IParagraph';
import { Editor } from '../../../../quillTextEditor/Editor';

export interface ParagraphComponentProps {
  data: ITheoryBlock<IParagraph>;
  onDelete: () => void;
  onUp: () => void;
  onDown: () => void;
}

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 16,
    background: 'rgba(0, 0, 0, 0.2)',
    padding: '16px 42px',
    '&:hover $actions': {
      visibility: 'visible',
    },
  },
  headerRow: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: '20px',
    alignItems: 'flex-end',
  },
  actions: {
    display: 'flex',
    gap: '8px',
    visibility: 'hidden',
  },
  title: {
    marginRight: 'auto',
  },
}));

export const ParagraphComponent = observer(
  ({ data: blockData, onDelete, onUp, onDown }: ParagraphComponentProps) => {
    const classes = useStyles();
    const editorRef = useRef<any>(null);
    const { data: paragraph, pseudoId } = blockData;

    const handleParagraphChange = useCallback(
      (newValue: string) => {
        paragraph.text = newValue;
      },
      [paragraph],
    );

    return (
      <Box key={pseudoId} className={classes.container}>
        <Box className={classes.headerRow}>
          <Typography className={classes.title}>
            <TranslateText i18nKey="createUnit.p" />
          </Typography>

          <Box className={classes.actions}>
            <DeleteForever fontSize="small" sx={{ cursor: 'pointer' }} onClick={onDelete} />
            <VisibilityOff fontSize="small" sx={{ cursor: 'pointer' }} onClick={() => {}} />
            <ArrowUpward fontSize="small" sx={{ cursor: 'pointer' }} onClick={onUp} />
            <ArrowDownward fontSize="small" sx={{ cursor: 'pointer' }} onClick={onDown} />
          </Box>
        </Box>

        <Editor
          ref={editorRef}
          defaultValue={paragraph.text}
          onTextChange={handleParagraphChange}
        />
      </Box>
    );
  }
);
